function togetherProduct(e) {
  //产品格子
  let productGrid=e.querySelectorAll(".together-item")
  //购买按钮表单
  let button = e.querySelector(".together-buy-bottom")
  //判断选中的产品,并更新价格
  const ingredients = e.querySelectorAll(".product-checkbox input");
  //产品总价格
  let totalPrice=0
  //产品数据
  let productItem = []
  //产品总数量
  let totalItem=ingredients.length
  //产品选中数量
  let itemNumber=0
  for(let item of ingredients){
    if(item.checked){
      itemNumber++
    }
  }
  //监听产品选中状态
  for (let i=0;i<ingredients.length;i++) {
      ingredients[i].addEventListener("click", ()=>{
        updateDisplay(i)
      });
  }
  //监听变体选项改变
  for(let dom of productGrid){
    let ul=dom.querySelector("ul")
    if(ul){
      ul.addEventListener("click",(el)=>{
        if(el.target.type=="radio"){
          changeVariants(el.target,dom)
        }
      })
    }
  }
  let map=new Map()
  updataProduct()
  //初始化数据
  function updataProduct(){
    map=new Map()
    totalPrice=0
    productItem=[]
    for(let dom of productGrid){
    productItem.push({
      "id":dom.getAttribute("data-product"),
      "price":Number.parseFloat(dom.getAttribute("data-product-price")),
    })
    let check = dom.querySelector(".product-checkbox input")
    if(check.checked){
      totalPrice+=Number.parseFloat(dom.getAttribute("data-product-price"))
    }
    }
    for (let i=0;i<ingredients.length;i++) {
        map.set(productItem[i].id,ingredients[i].checked?true:false)
    }
    upadateInfo()
  }
  
  //更新产品选中状态
  function updateDisplay(index) {
    if(ingredients[index].checked){
      itemNumber++
      totalPrice+=productItem[index].price
      map.set(productItem[index].id,true)
      e.querySelector(".together-buy-buttom").classList.remove("hidden")
      e.querySelector(".together-buy-info").classList.add("hidden")
    }else{
      itemNumber--
      totalPrice-=productItem[index].price
      map.set(productItem[index].id,false)
    }
    upadateInfo()
  }
  //更新购买按钮提示
  function upadateInfo(){
    e.querySelector(".together-buy-price").innerHTML=totalPrice.toFixed(2)
    e.querySelector(".together-buy-info").innerHTML='Choose items to buy together.'
    e.querySelector(".together-buy-buttom").classList.remove("hidden")
    e.querySelector(".together-buy-info").classList.add("hidden")
    switch(itemNumber){
      case totalItem:
        button.innerHTML=`Add All To Cart`
        break;
      case 0:
        e.querySelector(".together-buy-buttom").classList.add("hidden")
        e.querySelector(".together-buy-info").classList.remove("hidden")
        break;
      default:
        button.innerHTML=`Add ${itemNumber} To Cart`
    }
  }
  //更新变体
  function changeVariants(variantDom,productDom){
    let item={
      "id":variantDom.getAttribute("data-product"),
      "price":variantDom.getAttribute("data-product-price"),
      "img_src":variantDom.getAttribute("data-product-image-src")?variantDom.getAttribute("data-product-image-src"):null,
      "old_price":variantDom.getAttribute("data-product-old-price")?variantDom.getAttribute("data-product-old-price"):null,
    }
    productDom.setAttribute("data-product",item.id)
    productDom.setAttribute("data-product-price",item.price)
    let priceDom=productDom.querySelector(".together-product-price")
    let imgDom=productDom.querySelector(".together-product-img img")
    if(item.img_src){
      imgDom.src=item.img_src
    }
    if(item.old_price){
      priceDom.innerHTML=`<span class="old-price">$${item.old_price}</span>$${item.price}`
    }else{
      priceDom.innerHTML=`$${item.price}`
    }
    updataProduct()
  }
  //点击一起购买按钮
  function TogetherAddToCard() {
    if(button.classList.contains("processing"))return
    switchButton(true)
    //提交的产品数据表
    let success=false
    let formData = {'items': []};
    map.forEach((item,key)=>{
      if(item){
        formData.items.push({
            'id': key,
            'quantity': 1,
        })
      }
    })
      fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      })
      .then(response => {
        if(response.ok){
          while (document.getElementById('cart').childNodes.length >= 2) {
              document.getElementById('cart').removeChild(document.getElementById('cart').firstChild)
          }
           ajaxCart.load(false)
           switchButton(false)
          success=true
        }
        return response.json()
      })
      .then(response=>{
        if(!success){
          console.log(response)
          e.querySelector(".together-buy-buttom").classList.add("hidden")
          e.querySelector(".together-buy-info").classList.remove("hidden")
          e.querySelector(".together-buy-info").innerHTML=response.message
          switchButton(false)
        }
      })
  }
  button.addEventListener("click", () => {
      TogetherAddToCard()
  })

  //按钮加载状态
  function switchButton(state){
    state?button.classList.add("processing"):button.classList.remove("processing")
  }

  //滚动一起购买
  function togetherScroll(){
    let scrollContent = e.querySelector(".together-product-grid")
    let isDragging=false
    let startX=0
    //鼠标按下时
    scrollContent.addEventListener("mousedown",(mouse)=>{
      isDragging=true
      startX=mouse.pageX
    })
    //鼠标移动时
    scrollContent.addEventListener("mousemove",(mouse)=>{
      if(isDragging){
        let moveDistance=mouse.pageX-startX
        startX=mouse.clientX
        scrollContent.scrollBy({
            left: -moveDistance,
          })
      }
    })
    //鼠标松开时
    scrollContent.addEventListener("mouseup",()=>{
      isDragging=false
    })
    //鼠标离开时
    scrollContent.addEventListener("mouseleave",(mouse)=>{
      isDragging=false
    })
  }
  togetherScroll()
}
window.addEventListener('load', function() {
  let mainBody=document.querySelectorAll(".together-body")
  for(let item of mainBody){
    togetherProduct(item)
  }
});